<template>
  <div class="page-news-detail container" :data-cms="news._moduleId">
    <div v-if="loading" class="loading">
      <a-spin size="large"></a-spin>
    </div>
    <template v-else>
      <div class="cell-header">
        <h2>{{ news.title }}</h2>
        <P>{{ news.time }}</p>
      </div>
      <div class="cell-body">
        <div v-html="news.content"></div>
        <div class="goback-list">
          <router-link to="/news">返回列表</router-link>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import './index'

export default {
  data () {
    return {
      loading: true,
      news: {}
    }
  },
  created () {
    const { id } = this.$route.params

    if (!id) {
      this.$message.error('抱歉，找不到详情，即将返回列表页', () => {
        this.$router.replace('/news')
      })
    }

    this.fetch(id)
  },
  methods: {
    async fetch (id) {
      try {
        const data = await window.__MICRO_ROOT__.cms.fetchPageData(id)
        if (data) {
          this.news = data.news
          this.loading = false
        }
      } catch (err) {
        this.$message.error(err.message || '抱歉，找不到详情，即将返回列表页', () => {
          this.$router.replace('/news')
        })
      }
    }
  }
}
</script>
